import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import {AddIcon, EditIcon} from 'rambler-ui'
import {OnWidth} from '@rambler-id/react-utils'
import InternalHeader from 'components/InternalHeader'
import ProfileSection from 'components/ProfileSection'
import ProfileItem from 'components/ProfileItem'
import RowButton from 'components/RowButton'
import SettingsIcon from 'components/icons/SettingsIcon'
import AttentionIcon from 'components/icons/AttentionIcon'
import {CHANGE_PASSWORD, CHANGE_QUESTION, CHANGE_PHONE} from 'utils/urls'

import styles from './styles.css'

export default class Settings extends PureComponent {
  static propTypes = {
    type: PropTypes.string,
    info: PropTypes.object,
    emails: PropTypes.array
  }

  render() {
    const {type, info, emails} = this.props

    if (type !== 'general' && emails.length === 0) {
      return null
    }

    return (
      <ProfileSection
        section="settings"
        color="#7e57c2"
        icon={<SettingsIcon />}
      >
        <InternalHeader>
          <h2>
            <OnWidth>
              {(width) =>
                width < 768
                  ? 'Пароль и безопасность'
                  : 'Пароль и безопасность профиля'
              }
            </OnWidth>
          </h2>
          <p>
            {type === 'general'
              ? `
                Защитите свой профиль: своевременно меняйте пароль для входа,
                установите контрольный вопрос и привяжите телефон
                для восстановления доступа к почтовому ящику Рамблер/почты.
              `
              : 'Защитите свой профиль – своевременно меняйте пароль для входа.'}
          </p>
        </InternalHeader>
        <ProfileItem
          rightIcon={
            <RowButton
              label="Изменить пароль"
              container={<Link to={CHANGE_PASSWORD} />}
            >
              <EditIcon />
            </RowButton>
          }
          footer={
            <div className={styles.attention}>
              <OnWidth>
                {(width) => (
                  <AttentionIcon size={width < 768 ? 20 : 15} color="#6674A6" />
                )}
              </OnWidth>
              <a
                href="https://help.rambler.ru/id/o_parole/1660/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Рекомендации по созданию надежного пароля
              </a>
            </div>
          }
          cerberId="profile::security::change_password"
        >
          <Link to={CHANGE_PASSWORD}>Изменить пароль</Link>
        </ProfileItem>
        {type === 'general' && (
          <ProfileItem
            rightIcon={
              <RowButton
                label={`${
                  info.question ? 'Изменить' : 'Установить'
                } контрольный вопрос`}
                container={<Link to={CHANGE_QUESTION} />}
              >
                {info.question ? <EditIcon /> : <AddIcon />}
              </RowButton>
            }
            cerberId="profile::security::change_question"
          >
            <Link to={CHANGE_QUESTION}>
              {info.question ? 'Изменить' : 'Установить'} контрольный вопрос
            </Link>
          </ProfileItem>
        )}
        {type === 'general' && (
          <ProfileItem
            rightIcon={
              <RowButton
                label={`${
                  info.ramblerMailPhone ? 'Изменить' : 'Указать'
                } номер телефона`}
                container={<Link to={CHANGE_PHONE} />}
              >
                {info.ramblerMailPhone ? <EditIcon /> : <AddIcon />}
              </RowButton>
            }
            cerberId="profile::security::change_phone_for_access_recovery"
          >
            <Link to={CHANGE_PHONE}>
              {info.ramblerMailPhone ? 'Изменить' : 'Указать'} номер телефона
              для восстановления доступа
            </Link>
          </ProfileItem>
        )}
      </ProfileSection>
    )
  }
}
